import { render, staticRenderFns } from "./Paginate.vue?vue&type=template&id=32757fac&scoped=true&"
import script from "./Paginate.vue?vue&type=script&lang=js&"
export * from "./Paginate.vue?vue&type=script&lang=js&"
import style0 from "./Paginate.vue?vue&type=style&index=0&id=32757fac&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32757fac",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('32757fac')) {
      api.createRecord('32757fac', component.options)
    } else {
      api.reload('32757fac', component.options)
    }
    module.hot.accept("./Paginate.vue?vue&type=template&id=32757fac&scoped=true&", function () {
      api.rerender('32757fac', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2yu4VdMr6iiE8/JS/comp/Paginate.vue"
export default component.exports